import { Pipe, PipeTransform } from '@angular/core';
import { differenceInDays } from 'date-fns';

@Pipe({ name: 'dayDiff' })
export class HxDayDiffPipe implements PipeTransform {

  transform(date1: string, date2?: string): number | undefined {
    if (!date1 || !date2) {
      return;
    }

    return differenceInDays(new Date(date1), new Date(date2));
  }
}
